export default __webpack_public_path__ + "static/media/tethys-logo.1c98bacb.svg";